import validators from '@utils/validators';

const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.maxLength({value: values.output_client_references, maxLength: 100}, 'output_client_references'));
    Object.assign(errors, validators.maxLength({value: values.output_client_description, maxLength: 200}, 'output_client_description'));

    Object.assign(errors, validators.maxLength({value: values.output_client_references_edit, maxLength: 100}, 'output_client_references_edit'));
    Object.assign(errors, validators.maxLength({value: values.output_client_description, maxLength: 200}, 'output_client_description_edit'));

    return errors;
};

export default validate;
